<template>
  <span v-b-tooltip.hover :title="`${$t('task.priority.text')}: ${text}`">
    <i :class="icon" class="font-size-24 align-middle mr-2"></i>
    <span v-if="!onlyIcon" class="bold-text">{{ text }}</span>
  </span>
</template>

<script>
import { priorityOf, resolvePriorities } from "@/modules/task/task-settings";

export default {
  props: ["priority", "onlyIcon", "size"],
  computed: {
    icon() {
      if (this.priority == "1") {
        return "bx bx-chevron-down low";
      } else if (this.priority == "2") {
        return "iconoir-git-commit medium";
      } else if (this.priority == "3") {
        return "bx bx-chevron-up high";
      } else if (this.priority == "4") {
        return "bx bx-chevrons-up highest";
      }
      return "bx bxs-circle custom"; // TKP-119: özel öncelik (5+)
    },
    // TKP-119: ad organizasyonun öncelik kaydından (özel değerler dahil); kayıt yoksa sistem varsayılanları
    text() {
      const language = this.$store.getters["user/account"]?.language ?? "tr";
      return priorityOf(resolvePriorities(this.$store.getters["taskSettings/priorities"], language, (k) => this.$t(k)), this.priority).label;
    },
  },
};
</script>
<style scoped>
.custom {
  color: #6c757d;
}
.low {
  color: #458bee;
}
.medium {
  color: #ffc148;
}
.high {
  color: rgb(230, 107, 107);
}
.highest {
  color: red;
}
</style>
